import { createTheme } from "@mui/material/styles";
import { appSettings } from "./settings";

const theme = createTheme({
  palette: {
    primary: {
      main: appSettings.primaryColor,
    },
    secondary: {
      main: appSettings.secondaryColor,
    },
  },
  typography: {
    fontFamily: "'Nunito', 'Arial Rounded MT Bold', sans-serif",
  },
});

export default theme;